var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "boss-main-container" }, [
    _c(
      "div",
      { staticClass: "boss-main-wrap boss-main-content-wrap" },
      [
        _c("setting-header", {
          attrs: {
            breadcrumbs: [
              { name: "各種設定" },
              {
                name: "スカウトテンプレート一覧",
                pathName: "settingScoutTemplates",
              },
            ],
            title: "スカウトテンプレート" + _vm.formTypeLabel,
            "data-test": "title",
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "boss-scout-send-container" },
          [
            _c("form-item", {
              attrs: { "data-test": "text-template-title" },
              scopedSlots: _vm._u([
                {
                  key: "label",
                  fn: function () {
                    return [
                      _vm._v("\n          テンプレート名"),
                      _c("br"),
                      _vm._v(" "),
                      _c("small", [_vm._v("（50文字以内）")]),
                    ]
                  },
                  proxy: true,
                },
              ]),
              model: {
                value: _vm.message.name,
                callback: function ($$v) {
                  _vm.$set(_vm.message, "name", $$v)
                },
                expression: "message.name",
              },
            }),
            _vm._v(" "),
            _c("scout-mail-form", {
              on: { "change-invalid": _vm.changeInvalid },
              model: {
                value: _vm.message,
                callback: function ($$v) {
                  _vm.message = $$v
                },
                expression: "message",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "form-button-area",
          [
            _c("form-confirm-button", {
              attrs: {
                "is-disabled": _vm.isConfirmButtonDisabled,
                "submit-label":
                  "この内容でテンプレートを" + _vm.formTypeLabel + "する",
                "data-test": "confirm-button",
              },
              on: { "submit-event": _vm.onRegisterClick },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }